/** @format */

/**
 * NOTE: All dictionary values/keys must be in camel case
 */

const _x = {};
export default _x;
